import { SyncTableConfig } from "./types";

export const SMART_CONTEXTS_TABLE_CONFIG: SyncTableConfig = {
  shapeKey: "smart_contexts",
  table: "smart_contexts",
  columns: ["id", "associated_space_account_id", "payload_json", "created_at", "updated_at"],
  primaryKey: ["id"],
  parser: { timestamptz: (d: string) => new Date(d).toISOString() },
  enabled: false,
};
